import { ORIGINAL_LOOK } from "../renderConstants";

export type SlotLook =
  | { mode: "original" }
  | { mode: "emission"; color: string; strength: number }
  | { mode: "pulsingEmission"; color: string; strength: number };

export type SlotMode = SlotLook["mode"];

export type GlowingSlotLook = Exclude<SlotLook, { mode: "original" }>;

export function startingLookFor(mode: SlotMode): SlotLook {
  return mode === "original" ? ORIGINAL_LOOK : { mode, color: "#44ffcc", strength: 4 };
}
